"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ImgIX = _interopRequireDefault(require("./ImgIX"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CaptionedImage = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.ImageList, {
    cols: 1,
    sx: {
      marginY: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_material.ImageListItem, null, /*#__PURE__*/_react.default.createElement(_ImgIX.default, props), /*#__PURE__*/_react.default.createElement(_material.ImageListItemBar, {
    title: children || props.alt
  })));
};
CaptionedImage.defaultProps = {
  alt: ''
};
CaptionedImage.propTypes = {
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
};
var _default = exports.default = CaptionedImage;